/**
 * Lightweight shim replacing remotion's interpolate for web embed.
 * Only the subset used by edgen chart components is implemented.
 */

interface InterpolateOptions {
  extrapolateLeft?: "clamp" | "extend";
  extrapolateRight?: "clamp" | "extend";
}

export function interpolate(
  value: number,
  inputRange: [number, number],
  outputRange: [number, number],
  options?: InterpolateOptions,
): number {
  const [inMin, inMax] = inputRange;
  const [outMin, outMax] = outputRange;
  let t = (value - inMin) / (inMax - inMin);
  if (options?.extrapolateLeft === "clamp") {
    t = Math.max(0, t);
  }
  if (options?.extrapolateRight === "clamp") {
    t = Math.min(1, t);
  }
  return outMin + t * (outMax - outMin);
}
